module.exports = __webpack_public_path__ + "img/login-door.0ea45339.png";